import styled from "styled-components";
import { ToggleButton } from "@/ui";

export const StyledChatToggleButton = styled(ToggleButton)<{
  $active: boolean;
}>`
  ${({ $active }) => $active ? 'background-color: var(--color-text-80);' : ''}
`;
